import React, { memo, useEffect, useState } from 'react';
import { Col, FormGroup, Row } from 'reactstrap';

import { showMsg } from '../../services/library';
import CustomModal from '../../components/GeneralForm/CustomModal';
import CustomSelect from '../../components/GeneralForm/CustomSelect';
import CustomCheckbox from '../../components/GeneralForm/CustomCheckbox';
import DealerService from '../../services/dealerService';
import { WINDOW_STICKER_BANNER } from '../../constants/messageConst';

const WindowStickerBuyersguideOrderModal = props => {
  const {
    activeDealersList,
    dealer,
    windowStickerBuyersguideOrderToggle,
    handleFullLayoutLoader,
    modalTrigger
  } = props;

  const DropdownQtyOptions = [
    {
      label: '250 Sheets',
      value: '250 Sheets'
    },
    {
      label: '500 Sheets',
      value: '500 Sheets'
    },
    {
      label: '750 Sheets',
      value: '750 Sheets'
    }
  ];

  const [currentIndex, setCurrentIndex] = useState('');
  const [dealerId, setDealerId] = useState(0);
  const [wsChecked, setWsChecked] = useState(0);
  const [bgChecked, setBgChecked] = useState(0);
  const [adChecked, setAdChecked] = useState(0);

  const [wsDropdownSelection, setWsDropdownSelection] = useState(null);
  const [bgDropdownSelection, setBgDropdownSelection] = useState(null);
  const [adDropdownSelection, setAdDropdownSelection] = useState(null);

  useEffect(() => {
    setDealerId(dealer?.value || 0);
  }, [dealer, windowStickerBuyersguideOrderToggle]);

  // on change of current dealer
  useEffect(() => {
    if (dealerId && windowStickerBuyersguideOrderToggle) {
      let index = activeDealersList.findIndex(opt => opt.value === dealerId);
      if (index >= 0) {
        setCurrentIndex(index);
      }
    }
  }, [activeDealersList, dealerId, windowStickerBuyersguideOrderToggle]);

  const closeModal = () => {
    modalTrigger();
    setDealerId(0);
    setCurrentIndex('');
    setWsChecked(0);
    setBgChecked(0);
    setAdChecked(0);
    setWsDropdownSelection(null);
    setBgDropdownSelection(null);
    setAdDropdownSelection(null);
  };

  const savewindowStickerBuyersguideOrder = data => {
    handleFullLayoutLoader(true);
    DealerService.windowStickerBuyersguideOrder(data)
      .then(response => {
        if (response.status) {
          showMsg(response.message, 'success');
          closeModal();
        } else {
          return showMsg(response.errors, 'error');
        }
      })
      .catch(error => {
        showMsg(error, 'error');
      })
      .finally(() => {
        handleFullLayoutLoader(false);
      });
  };

  const submittedData = () => {
    // Validate
    const dId = parseInt(dealerId);
    const isChecked = wsChecked + bgChecked + adChecked;
    const errMSG = [];
    if (!dId) {
      errMSG.push('Dealer is required.');
    }
    if (isChecked < 1) {
      errMSG.push('Please select at least one item.');
    }
    if (wsChecked && !wsDropdownSelection?.value) {
      errMSG.push('Window Stickers Quantity required.');
    }
    if (bgChecked && !bgDropdownSelection?.value) {
      errMSG.push('Buyers Guide Quantity required.');
    }
    if (adChecked && !adDropdownSelection?.value) {
      errMSG.push('Addendums Quantity required.');
    }
    if (errMSG.length > 0) {
      showMsg(errMSG, 'error');
      return false;
    }
    // call api
    savewindowStickerBuyersguideOrder({
      dealer_id: dealerId,
      wsChecked,
      wsQty: wsDropdownSelection?.value || '',
      bgChecked,
      bgQty: bgDropdownSelection?.value || '',
      adChecked,
      adQty: adDropdownSelection?.value || ''
    });
  };

  return (
    <CustomModal
      isOpen={windowStickerBuyersguideOrderToggle}
      closeClick={closeModal}
      modalSize="md"
      saveClick={submittedData}
      modalTitle="Order Window Stickers &/or Buyer's Guides"
      submitButtonName="Send"
    >
      <div className="d-flex mb-2">
        <span className="ml-auto align-self-start small">
          <span className="text-danger">*</span>
          Required Field
        </span>
      </div>
      <div
        className="d-flex flex-row flex-no-wrap flex-justify-content-start align-items-baseline p-3 rounded mb-2"
        style={{ background: 'var(--dark) !important', color: 'var(--info)', fontWeight: 600 }}
      >
        <i className="fa fa-fw fa-bullhorn mr-2 align-top" aria-hidden="true" />
        {WINDOW_STICKER_BANNER}
      </div>
      {/* <div className="d-flex mb-4">
        <div>
          <i className="fa fa-bullhorn text-danger mr-2" aria-hidden="true" />
        </div>
        <span>
          <span className="text-danger">{WINDOW_STICKER_BANNER}</span>
        </span>
      </div> */}
      <Row>
        <Col>
          <FormGroup row>
            <Col>
              <CustomSelect
                id="dId"
                size="md"
                placeholder="Select Dealership"
                options={activeDealersList}
                selected={currentIndex < 0 ? '' : activeDealersList[currentIndex]}
                onChange={dealer => {
                  setDealerId(dealer?.value);
                }}
              />
            </Col>
          </FormGroup>
          <Row className="align-items-baseline">
            <Col className="col-md-6 col-6">
              <CustomCheckbox
                id="wsChecked"
                labelName="Window Stickers"
                checked={wsChecked}
                onChange={e => {
                  setWsChecked(+e.currentTarget.checked);
                  setWsDropdownSelection(null);
                }}
              />
            </Col>
            <Col className="col-md-6 col-6">
              <CustomSelect
                isDisabled={!wsChecked}
                onChange={e => setWsDropdownSelection(e)}
                options={DropdownQtyOptions}
                selected={
                  wsDropdownSelection
                    ? DropdownQtyOptions.find(d => d.value === wsDropdownSelection?.value)
                    : null
                }
              />
            </Col>
          </Row>
          <Row className="mt-3 align-items-baseline">
            <Col className="col-md-6 col-6">
              <CustomCheckbox
                id="bgChecked"
                labelName="Buyers Guide"
                checked={bgChecked}
                onChange={e => {
                  setBgChecked(+e.currentTarget.checked);
                  setBgDropdownSelection(null);
                }}
              />
            </Col>
            <Col className="col-md-6 col-6">
              <CustomSelect
                isDisabled={!bgChecked}
                onChange={e => setBgDropdownSelection(e)}
                options={DropdownQtyOptions}
                selected={
                  bgDropdownSelection
                    ? DropdownQtyOptions.find(d => d.value === bgDropdownSelection?.value)
                    : null
                }
              />
            </Col>
          </Row>
          <Row className="mt-3 mb-2 align-items-baseline">
            <Col className="col-md-6 col-6">
              <CustomCheckbox
                id="adChecked"
                labelName="Addendums"
                checked={adChecked}
                onChange={e => {
                  setAdChecked(+e.currentTarget.checked);
                  setAdDropdownSelection(null);
                }}
              />
            </Col>
            <Col className="col-md-6 col-6">
              <CustomSelect
                isDisabled={!adChecked}
                options={DropdownQtyOptions}
                onChange={e => setAdDropdownSelection(e)}
                selected={
                  adDropdownSelection
                    ? DropdownQtyOptions.find(d => d.value === adDropdownSelection?.value)
                    : null
                }
              />
            </Col>
          </Row>
        </Col>
      </Row>
    </CustomModal>
  );
};

WindowStickerBuyersguideOrderModal.displayName = 'WindowStickerBuyersguideOrderModal';
export default memo(WindowStickerBuyersguideOrderModal);
